import { buildModelManager } from "../builder.js";
const DefaultPatientEncounterSelection = {
  __typename: true,
  id: true,
  abdomenAssessment: { markdown: true, truncatedHTML: true },
  airwayManagementRequired: true,
  airwayManagementSuccess: true,
  allergies: { markdown: true, truncatedHTML: true },
  arrestWitnessedBy: true,
  avpuScore: true,
  bgl: true,
  bglUta: true,
  cardiacAssessment: { markdown: true, truncatedHTML: true },
  causeOfInjury: true,
  chestAssessment: { markdown: true, truncatedHTML: true },
  chiefComplaint: { markdown: true, truncatedHTML: true },
  cohort: true,
  createdAt: true,
  diastolicBP: true,
  diastolicBPUta: true,
  differentialDiagnosis: { markdown: true, truncatedHTML: true },
  encounterDate: true,
  etco2: true,
  etco2Uta: true,
  eventsPrior: { markdown: true, truncatedHTML: true },
  extremitiesAssessment: { markdown: true, truncatedHTML: true },
  fieldImpressions: { markdown: true, truncatedHTML: true },
  heartRate: true,
  heartRateUta: true,
  heartSounds: { markdown: true, truncatedHTML: true },
  heentAssessment: { markdown: true, truncatedHTML: true },
  historyPresentIllness: { markdown: true, truncatedHTML: true },
  institution: true,
  intentOfInjury: true,
  lastOralIntake: { markdown: true, truncatedHTML: true },
  lungSounds: { markdown: true, truncatedHTML: true },
  mechanismOfInjury: true,
  medications: { markdown: true, truncatedHTML: true },
  mentalStatus: { markdown: true, truncatedHTML: true },
  neckBackAssessment: { markdown: true, truncatedHTML: true },
  neurologicalAssessment: { markdown: true, truncatedHTML: true },
  onsetTiming: { markdown: true, truncatedHTML: true },
  oxygenSaturation: true,
  oxygenSaturationUta: true,
  pastMedicalHistory: { markdown: true, truncatedHTML: true },
  patientAge: true,
  patientAgeMonths: true,
  patientAlertLevel: true,
  patientBiologicalSex: true,
  patientCriticality: true,
  patientEthnicity: true,
  patientGender: true,
  patientPronouns: true,
  performedExam: true,
  performedInterview: true,
  postIncidentReflection: { markdown: true, truncatedHTML: true },
  preceptorId: true,
  primaryImpression: true,
  provocationPalliation: { markdown: true, truncatedHTML: true },
  qaDocumentationCriteria: { markdown: true, truncatedHTML: true },
  quality: { markdown: true, truncatedHTML: true },
  radiation: { markdown: true, truncatedHTML: true },
  reassessmentResponse: { markdown: true, truncatedHTML: true },
  respiratoryRate: true,
  respiratoryRateUta: true,
  returnOfPulse: true,
  reviewStatus: true,
  reviewedById: true,
  secondaryImpression: true,
  severity: { markdown: true, truncatedHTML: true },
  shiftDocumentationId: true,
  shiftId: true,
  skinAssessment: { markdown: true, truncatedHTML: true },
  studentId: true,
  submittedById: true,
  systolicBP: true,
  systolicBPUta: true,
  temperature: true,
  temperatureUta: true,
  timing: { markdown: true, truncatedHTML: true },
  transportDisposition: { markdown: true, truncatedHTML: true },
  treatmentInterventions: { markdown: true, truncatedHTML: true },
  updatedAt: true
};
const modelApiIdentifier = "patientEncounter";
const pluralModelApiIdentifier = "patientEncounters";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPatientEncounterSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPatientEncounterSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPatientEncounterSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPatientEncounterSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPatientEncounterSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPatientEncounterSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPatientEncounterSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createPatientEncounter",
    operationReturnType: "CreatePatientEncounter",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      patientEncounter: { required: false, type: "CreatePatientEncounterInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPatientEncounterSelection
  },
  {
    type: "action",
    operationName: "bulkCreatePatientEncounters",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreatePatientEncountersInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPatientEncounterSelection
  },
  {
    type: "action",
    operationName: "updatePatientEncounter",
    operationReturnType: "UpdatePatientEncounter",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      patientEncounter: { required: false, type: "UpdatePatientEncounterInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPatientEncounterSelection
  },
  {
    type: "action",
    operationName: "bulkUpdatePatientEncounters",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdatePatientEncountersInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPatientEncounterSelection
  },
  {
    type: "action",
    operationName: "deletePatientEncounter",
    operationReturnType: "DeletePatientEncounter",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeletePatientEncounters",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertPatientEncounter",
    operationReturnType: "UpsertPatientEncounter",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      patientEncounter: { required: false, type: "UpsertPatientEncounterInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreatePatientEncounterResult": { hasReturnType: false },
      "... on UpdatePatientEncounterResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPatientEncounterSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertPatientEncounters",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertPatientEncountersInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultPatientEncounterSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "patientEncounterGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const PatientEncounterManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultPatientEncounterSelection,
  operations
);
export {
  DefaultPatientEncounterSelection,
  PatientEncounterManager
};
//# sourceMappingURL=PatientEncounter.js.map
